import React, { Component } from 'react';
import { DatePickerRow } from '@eg/elements/DatePickerRow';
import { Button } from '@eg/elements/Button';
import { ArrowRightIcon } from '@eg/elements/Icons/ArrowRightIcon';
import { FormSection } from '@eg/elements/FormSection';

import CheckoutNavigation from '../../../components/shared/checkout-navigation/CheckoutNavigation';
import PrivacyInformation from '../../../components/shared/privacy-information/PrivacyInformation';
import FirstInformation from '../../../components/shared/first-information/FirstInformation';
import ProductTable from './ProductTable';
import './ProductOverview.scss'

class ProductOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      insuranceStartDate: undefined,
      minDate: undefined,
      maxDate: undefined,
      error: false,
      advertiserID: ''
    };
  }

  componentDidMount(){
    var currentDate = new Date();
    var minDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
    var maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 3, currentDate.getDate());

    var insuranceStart = sessionStorage.getItem('insuranceStartDate');
    var insuranceStartDate;
    var urlANR = this.getUrlData('ANR');

    if(urlANR !== undefined) {
      this.setState({advertiserID: urlANR});
    }

    // Check session storage value
    if(insuranceStart !== undefined && insuranceStart !== null) {
      insuranceStartDate = new Date(insuranceStart);
    } else {
      insuranceStartDate = minDate;
    }

    // Check min and max date value
    if(insuranceStartDate < minDate) {
      insuranceStartDate = minDate;
    }
    if(insuranceStartDate > maxDate) {
       insuranceStartDate = maxDate
    }

    sessionStorage.setItem('insuranceStartDate', insuranceStartDate);

    this.setState({ insuranceStartDate: insuranceStartDate });
    this.setState({ minDate: minDate });
    this.setState({ maxDate: maxDate });
  }

  handleChange = (insuranceStartDate) => {
    if(insuranceStartDate === undefined || insuranceStartDate === null) {
      this.setState({ insuranceStartDate: undefined });
      this.setState({ error: true });
    } else {
      this.setState({ insuranceStartDate: insuranceStartDate });
      this.setState({ error: false });
    }
  }

  handleSubmit = () => {
    if(this.state.insuranceStartDate === undefined || this.state.insuranceStartDate === null) {
      this.setState({error: true});

      return;
    }

    sessionStorage.setItem('insuranceStartDate', this.state.insuranceStartDate);
    sessionStorage.setItem('timestamp', new Date());

    if(this.state.advertiserID !== undefined && this.state.advertiserID !== null && this.state.advertiserID !== '') {
      this.props.history.push("/internet-schutzbrief/persoenliches?ANR=" + this.state.advertiserID);
    } else {
      this.props.history.push("/internet-schutzbrief/persoenliches");
    }

    window.scrollTo(0, 0);

    return;
  }

  getUrlData = (variable) => {
    var url = window.location.search.substring(1);
    var data = url.split("?");

    for (var i=0; i<data.length; i++) {
        var pair = data[i].split("=");
        if(pair[0] === variable) {
          return pair[1];
      }
    }
  }

  render() {
    return(
      <div className="esc_container outerContainer" id="product-overview">
        <div className="esc_container esc_container--l">
          <CheckoutNavigation step="0" />
          <PrivacyInformation />

          <ProductTable />

          <FormSection id="form" heading="Versicherungsbeginn">
            <DatePickerRow
              label="Gewünschter Versicherungsbeginn"
              valueDate={this.state.insuranceStartDate}
              minDate={this.state.minDate}
              maxDate={this.state.maxDate}
              onChange={(e, date) => this.handleChange(date)}
              error={this.state.error ? "Bitte Startdatum angeben." : false}
            />
          </FormSection>
          <FirstInformation />
          <Button variant="primary" iconRight={ArrowRightIcon} size="auto" onClick={this.handleSubmit} disabled={this.state.error}>Weiter</Button>
        </div>
      </div>
    );
  }
}

export default ProductOverview;
